export default {
  title: 'Watchlists',
  createWlDialog: {
    title: 'Create New List',
    showMoviesTitle: 'All Movies & Shows',
  },
};
